import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

interface RuntimeConfig {
  maintenanceEnabled?: boolean;
  maintenanceEtaIso?: string;
  maintenanceEtaText?: string;
  maintenanceTitle?: string;
  maintenanceSubtitle?: string;
  maintenanceFooter?: string;
}

const NO_CACHE_HEADERS = new HttpHeaders({
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  'Pragma': 'no-cache',
});

@Injectable({
  providedIn: 'root',
})
export class RuntimeConfigService {
  private config: RuntimeConfig = {};

  constructor(private readonly http: HttpClient) {}

  load(): Promise<void> {
    const url = `/assets/runtime-config.json?t=${Date.now()}`;
    return firstValueFrom(this.http.get<RuntimeConfig>(url, { headers: NO_CACHE_HEADERS }))
      .then((runtimeConfig) => {
        this.config = runtimeConfig || {};
      })
      .catch(() => {});
  }

  get maintenanceEnabled(): boolean {
    if (typeof this.config.maintenanceEnabled === 'boolean') {
      return this.config.maintenanceEnabled;
    }
    return environment.maintenanceMode;
  }

  get maintenanceEtaIso(): string {
    return this.config.maintenanceEtaIso || '';
  }

  get maintenanceEtaText(): string {
    return this.config.maintenanceEtaText || 'Expected completion: ~30 minutes';
  }

  get maintenanceTitle(): string {
    return this.config.maintenanceTitle || 'Volta is undergoing scheduled maintenance';
  }

  get maintenanceSubtitle(): string {
    return this.config.maintenanceSubtitle || 'We will be back shortly.';
  }

  get maintenanceFooter(): string {
    return this.config.maintenanceFooter || 'Your data is safe. No action required.';
  }
}
